import { useColors } from '../../hooks/useColors'

type Props = { formData: Record<string, string>; onChange: (key: string, value: string) => void }

export default function AgentSettingsTab({ formData, onChange }: Props) {
  const colors = useColors()
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <h3 style={{ margin: 0, color: colors.textPrimary }}>Agent Settings</h3>
      <input type="time" value={formData.operational_hours_start || ''} onChange={(e) => onChange('operational_hours_start', e.target.value)} />
      <input type="time" value={formData.operational_hours_end || ''} onChange={(e) => onChange('operational_hours_end', e.target.value)} />
      <input value={formData.max_radius_km || ''} onChange={(e) => onChange('max_radius_km', e.target.value)} placeholder="Max Radius (km)" />
      <label style={{ color: colors.textPrimary }}>
        <input type="checkbox" checked={String(formData.accept_new_orders) === 'true'} onChange={(e) => onChange('accept_new_orders', e.target.checked ? 'true' : 'false')} /> Accept New Orders
      </label>
    </div>
  )
}
